import { Tooltip, Typography, useTheme } from '@mui/material';
import { MdInfoOutline } from '@teamworksdev/icons';
import { cn } from '../utils';

type InfoTooltipProps = {
  className?: string;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
};

export function InfoTooltip(props: InfoTooltipProps) {
  const { className, icon } = props;
  const title = props.title;
  const description = props.description;
  const {
    palette: {
      mediumEmphasisTextDark,
      common: { white },
    },
  } = useTheme();

  return (
    <Tooltip
      placement="top"
      title={
        <div className="p-1">
          {title && (
            <Typography variant="subtitle1Semibold" color={white}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography variant="subtitle1" color={mediumEmphasisTextDark}>
              {description}
            </Typography>
          )}
        </div>
      }
      arrow
      className={cn('flex items-center', className)}
    >
      <div>{icon ?? <MdInfoOutline size={16} />}</div>
    </Tooltip>
  );
}
